import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

const ImgPersonalColor = () => {
  return (
    <Svg width={36} height={36} viewBox="0 0 36 36">
      <Defs>
        <ClipPath id="clip">
          <Rect x={0} y={0} width={36} height={36} />
        </ClipPath>
      </Defs>
      <G clipPath="url(#clip)">
        <Path
          d="M5.818,6.924C6.107,6.13 6.791,5.546 7.621,5.385L12.514,4.437C12.943,4.354 13.385,4.389 13.795,4.538L31.251,10.892C32.5,11.346 33.143,12.726 32.689,13.975L28.164,26.407C27.71,27.655 26.33,28.299 25.081,27.844L7.624,21.491C7.215,21.341 6.853,21.084 6.579,20.745L3.439,16.873C2.907,16.217 2.758,15.33 3.047,14.536L5.818,6.924ZM10.649,12.992C10.932,12.212 10.53,11.349 9.75,11.065C8.97,10.781 8.107,11.184 7.823,11.964C7.539,12.744 7.941,13.607 8.722,13.891C9.502,14.175 10.365,13.772 10.649,12.992Z"
          fill="#FFD983"
          fillRule="evenodd"
        />
        <Path
          d="M7.748,4.487C8.291,3.84 9.134,3.525 9.968,3.658L14.891,4.441C15.322,4.509 15.725,4.694 16.059,4.974L30.29,16.915C31.308,17.769 31.441,19.286 30.587,20.304L22.083,30.438C21.229,31.456 19.712,31.589 18.694,30.735L4.463,18.794C4.129,18.514 3.878,18.148 3.735,17.736L2.11,13.024C1.834,12.225 1.998,11.34 2.541,10.693L7.748,4.487ZM10.212,11.842C10.745,11.206 10.662,10.258 10.026,9.724C9.39,9.19 8.442,9.273 7.908,9.909C7.374,10.545 7.457,11.494 8.094,12.027C8.73,12.561 9.678,12.478 10.212,11.842Z"
          fill="#BED8FE"
          fillRule="evenodd"
        />
        <Path
          d="M10.319,4.578C11.051,4.155 11.951,4.148 12.69,4.558L17.048,6.977C17.429,7.189 17.746,7.5 17.964,7.878L27.252,23.966C27.916,25.116 27.522,26.587 26.372,27.252L14.914,33.867C13.764,34.531 12.293,34.137 11.628,32.986L2.34,16.898C2.122,16.52 2.011,16.091 2.018,15.655L2.102,10.671C2.116,9.826 2.572,9.05 3.304,8.628L10.319,4.578ZM10.119,12.332C10.838,11.916 11.085,10.997 10.67,10.278C10.254,9.559 9.335,9.312 8.616,9.728C7.897,10.143 7.65,11.062 8.066,11.781C8.481,12.5 9.4,12.747 10.119,12.332Z"
          fill="#FFB8B8"
          fillRule="evenodd"
        />
        <Path
          d="M9.914,11.578m-1.971,1.138a2.276,2.276 105,1 1,3.942 -2.276a2.276,2.276 105,1 1,-3.942 2.276"
          stroke="#A36C52"
          strokeWidth={1.25}
          fill="transparent"
        />
        <Path
          d="M9.914,11.578m-1.427,0.824a1.648,1.648 105,1 1,2.854 -1.648a1.648,1.648 105,1 1,-2.854 1.648"
          fill="#3A3A3A"
        />
        <Path
          d="M1.866,5.78L1.866,5.78A1.135,1.135 80.38,0 0,2.134 7.363L8.334,11.766A1.135,1.135 80.38,0 0,9.917 11.497L9.917,11.497A1.135,1.135 80.38,0 0,9.648 9.915L3.448,5.512A1.135,1.135 80.38,0 0,1.866 5.78z"
          fill="#AD9087"
        />
      </G>
    </Svg>
  );
};

export default ImgPersonalColor;
